import axios from 'axios'

export const EnterpriseApi = {
    http: axios.create(),
    acceptInvitation(data) {
        return this.http.patch(Routing.generate('update_enterprise_invitation'), {
            invitation_id: data.invitation_id,
            response_status: data.response_status
        });
    },
    getTitles(enterpriseId) {
        const apiUrl = Routing.generate('get_enterprise_titles', {enterpriseId: enterpriseId});
        return this.http.get(apiUrl).then((res) => {
            return res.data;
        });
    }, syncTitles(enterpriseId, documentIds) {
        const apiUrl = Routing.generate('update_enterprise_titles', {enterpriseId: enterpriseId});
        return this.http.post(apiUrl, {ids: documentIds}).then((res) => {
            return res.data;
        });
    }, addTitles(enterpriseId, documentIds) {
        const apiUrl = Routing.generate('update_enterprise_titles', {enterpriseId: enterpriseId});
        return this.http.post(apiUrl, {add: documentIds}).then((res) => {
            return res.data;
        });
    }, removeTitles(enterpriseId, documentIds) {
        const apiUrl = Routing.generate('update_enterprise_titles', {enterpriseId: enterpriseId});
        return this.http.post(apiUrl, {remove: documentIds}).then((res) => {
            return res.data;
        });
    }, clearTitlesCache(enterpriseId) {
        const apiUrl = Routing.generate('delete_enterprise_titles_cache', {enterpriseId: enterpriseId});
        return this.http.delete(apiUrl).then((res) => {
            return res.data;
        });
    }
}
